var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoFavorites = function SvgNoFavorites(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#noFavorites_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A19A",
    d: "M59.728 61.67c4.166 0 7.544-1.909 7.544-4.264 0-2.354-3.378-4.263-7.544-4.263s-7.543 1.909-7.543 4.263 3.377 4.264 7.543 4.264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A19A",
    fillRule: "evenodd",
    d: "m65.773 39.727-5.44 6.2v-.01l-7.044-7.219c-11.744-12.04-13.616-25.233-4.68-33.717 7.312-6.95 17.144-6.519 24.188.7 8.34 8.565 6.304 18.776-7.024 34.046m-12.97-26.208c.923-.892 2.197-1.453 3.636-1.351 2.496.175 3.95 1.983 3.95 1.983 1.3-1.272 2.655-1.89 3.947-1.98 1.437-.1 2.709.465 3.63 1.358 1.815 1.76 2.38 4.937.135 7.12l-.021.019-7.302 6.429a.59.59 0 0 1-.78 0l-7.3-6.43-.02-.019c-2.258-2.194-1.697-5.37.125-7.129",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFA",
    d: "M114.23 105.59c-4.5 6.48-13.04 9.22-20.31 9.38-18.39.62-35.02-9.67-52.58-12.42-12.22-2.07-27.04.76-33.23 12.59-1.97 3.66-2.87 7.95-2.09 12.01l-2.58.54c-2.07-9.57 3.4-19.34 11.37-24.45 4-2.57 8.57-4.12 13.19-4.85 18.4-2.99 35.47 6.54 52.96 9.49 10.38 1.82 26.67 1.38 29.32-10.99.8-7.51-6.56-13.03-13.36-14.31-8.4-1.77-17.28.29-26.03.09-7.6-.18-17.76-.49-15-11.21.34-1.76 1.05-3.7 1.02-5.46.73.14 1.52.21 2.33.21.74 0 1.46-.06 2.13-.17-.13.59-.31 1.01-.52 1.58-.99 2.8-3.77 7.2-1.8 9.77 4.89 4.16 18.45-.08 24.79-.67 4.53-.61 9.27-.98 14.16-.29 14.05 1.44 25.48 16.28 16.23 29.16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "noFavorites_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgNoFavorites;